<div class="legal">
  <div class="legal-header">
    <h2>{{ 'legalTitle' | translate }}</h2>
  </div>

  <div class="legal-body">
    <h3>{{ 'policyTitle1' | translate }}</h3>
    <p>{{ 'policyText1' | translate }}</p>

    <h3>{{ 'policyTitle2' | translate }}</h3>
    <p>{{ 'policyText2' | translate }}</p>

    <h3>{{ 'policyTitle3' | translate }}</h3>
    <p>{{ 'policyText3' | translate }}</p>
    <p>{{ 'policyText3_1' | translate | removeBullet }}</p>
    <p>{{ 'policyText3_2' | translate | removeBullet}}</p>
    <p>{{ 'policyText3_3' | translate | removeBullet}}</p>
    <p>{{ 'policyText3_4' | translate | removeBullet}}</p>
    <p>{{ 'policyText3_5' | translate | removeBullet}}</p>

    <h3>{{ 'policyTitle4' | translate }}</h3>
    <p>{{ 'policyText4_1' | translate | removeBullet }}</p>
    <p>{{ 'policyText4_2' | translate | removeBullet }}</p>
    <p>{{ 'policyText4_3' | translate | removeBullet }}</p>
    <p>{{ 'policyText4_4' | translate | removeBullet }}</p>
    <p>{{ 'policyText4_5' | translate | removeBullet }}</p>
    <p>{{ 'policyText4_6' | translate | removeBullet }}</p>
    <p>{{ 'policyText4_7' | translate | removeBullet }}</p>

    <h3>{{ 'policyTitle5' | translate }}</h3>
    <p>{{ 'policyText5' | translate }}</p>
    <p>{{ 'policyText5_1' | translate | removeBullet }}</p>
    <p>{{ 'policyText5_2' | translate | removeBullet }}</p>
    <p>{{ 'policyText5_3' | translate }}</p>

    <h3>{{ 'policyTitle6' | translate }}</h3>
    <p>{{ 'policyText6_1' | translate | removeBullet }}</p>
    <p>{{ 'policyText6_2' | translate | removeBullet }}</p>
    <p>{{ 'policyText6_3' | translate | removeBullet }}</p>

    <h3>{{ 'policyTitle7' | translate }}</h3>
    <p>{{ 'policyText7' | translate }}</p>
    <p>{{ 'policyText7_1' | translate | removeBullet }}</p>
    <p>{{ 'policyText7_2' | translate | removeBullet }}</p>

    <h3>{{ 'policyTitle8' | translate }}</h3>
    <p>{{ 'policyText8_1' | translate }}</p>
    <p>{{ 'policyText8_2' | translate }}</p>

    <h3>{{ 'policyTitle9' | translate }}</h3>
    <p>{{ 'policyText9' | translate }}</p>

    <h3>{{ 'policyTitle10' | translate }}</h3>
    <p>{{ 'policyText10_1' | translate }}</p>
    <p>{{ 'policyText10_2' | translate }}</p>

    <h3>{{ 'policyTitle11' | translate }}</h3>
    <p>{{ 'policyText11' | translate }}</p>

    <h3>{{ 'policyTitle12' | translate }}</h3>
    <p>{{ 'policyText12' | translate }}</p>


    <h3>{{ 'policyTitle13' | translate }}</h3>
    <p>{{ 'policyText13_1' | translate }}</p>
    <p>{{ 'policyText13_2' | translate }}</p>

    <h3>{{ 'policyTitle14' | translate }}</h3>
    <p>{{ 'policyText14' | translate }}</p>
    <p>{{ 'policyText14_1' | translate | removeBullet }}</p>
    <p>{{ 'policyText14_2' | translate | removeBullet }}</p>
    <p>{{ 'policyText14_3' | translate | removeBullet }}</p>
    <p>{{ 'policyText14_4' | translate | removeBullet }}</p>
    <p>{{ 'policyText14_5' | translate }}</p>


    <h3>{{ 'policyEnd' | translate }}</h3>

  </div>

  <div class="legal-footer">
    <button (click)="close()">{{ 'close' | translate }}</button>
  </div>
</div>
